export default __webpack_public_path__ + "static/media/rockslope.0500e2be.png";